<template>
  <div class="container_box details_box_styles">
    <!--审核提示（悬浮固定顶部展示）-->
    <div class="audit_alerts_wrapper" v-if="activeAuditAlerts.length > 0">
      <Alert
        v-for="alert in activeAuditAlerts"
        :key="alert.key"
        class="alert_content_box"
        :type="alert.alertType"
        show-icon>
        <div class="flex align-items-center">
          <span>{{ alert.text }}</span>
          <span v-if="alert.hasRejectReason" class="themeColor cursor ml10" @click="showRejectReason(alert.label)">{{ $t('key1006794') }}</span>
          <span v-if="alert.status === 2" class="themeColor cursor ml10" @click="closeAuditAlert(alert.type)">{{ $t('key1000902') }}</span>
        </div>
      </Alert>
    </div>
    <!--企业信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002793') }}</h2>
        </template>
        <Form :model="enterpriseInfoForm" ref="enterpriseInfoForm" :rules="enterpriseInfoRuleValidate" :label-width="170" @submit.native.prevent>
          <Row>
            <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
              <template v-for="item in multilingualNamesList">
                <template :slot="item.name">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                      <span v-if="!editPriseInfo">{{ enterpriseInfoForm['name_' + item.code] || '-' }}</span>
                      <Input v-else v-model.trim="enterpriseInfoForm['name_' + item.code]" clearable :maxlength="255" class="width_350"></Input>
                    </Form-item>
                  </Col>
                </template>
              </template>
            </languagesTabs>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002766')" class="required_style_label">
                <Upload
                  class="upload_styles"
                  ref="upload"
                  type="drag"
                  name="files"
                  v-if="editPriseInfo"
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'businessLicensePath')"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="20480"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <div class="img_style" v-if="enterpriseInfoForm.businessLicensePath">
                    <img :src="setImgPath(enterpriseInfoForm.businessLicensePath)" alt=""/>
                  </div>
                  <div class="upload_icon_box" v-else>
                    <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(enterpriseInfoForm.businessLicensePath)" alt=""/>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002767')" class="required_style_label">
                <div class="flex align-items-center">
                  <Upload
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    v-if="editPriseInfo"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="img_style" v-if="enterpriseInfoForm.identificationCardPath">
                      <img :src="setImgPath(enterpriseInfoForm.identificationCardPath)" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1002795') }}</p>
                    </div>
                  </Upload>
                  <img v-else class="viewImgStyles mr20" v-viewer="viewerOptions" :src="setImgPath(enterpriseInfoForm.identificationCardPath)" alt=""/>
                  <Upload
                    class="upload_styles ml20"
                    ref="upload"
                    type="drag"
                    name="files"
                    v-if="editPriseInfo"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardBackPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="img_style" v-if="enterpriseInfoForm.identificationCardBackPath">
                      <img :src="setImgPath(enterpriseInfoForm.identificationCardBackPath)" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1002796') }}</p>
                    </div>
                  </Upload>
                  <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(enterpriseInfoForm.identificationCardBackPath)" alt=""/>
                </div>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002768')" prop="scale">
                <span v-if="!editPriseInfo" class="labelText">{{ enterpriseInfoForm.scaleName }}</span>
                <Select v-else v-model="enterpriseInfoForm.scale" filterable :placeholder="$t('key1000101')" class="width_350">
                  <Option v-for="item in scaleList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002769')" prop="contacts">
                <span v-if="!editPriseInfo" class="labelText">{{ enterpriseInfoForm.contacts || '-' }}</span>
                <Input v-else v-model.trim="enterpriseInfoForm.contacts" :placeholder="$t('key1002770')" clearable class="width_350"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002771')" prop="contactsPhone">
                <span v-if="!editPriseInfo" class="labelText">{{ enterpriseInfoForm.contactsPhone || '-' }}</span>
                <Input v-else v-model.trim="enterpriseInfoForm.contactsPhone" :placeholder="$t('key1002772')" clearable class="width_350"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001175')" prop="phone">
                <span v-if="!editPriseInfo" class="labelText">{{ enterpriseInfoForm.phone || '-' }}</span>
                <Input v-else v-model.trim="enterpriseInfoForm.phone" :placeholder="$t('key1002773')" clearable class="width_350"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1000068')" prop="email">
                <span v-if="!editPriseInfo" class="labelText">{{ enterpriseInfoForm.email || '-' }}</span>
                <Input v-else v-model.trim="enterpriseInfoForm.email" :placeholder="$t('key1002765')" clearable class="width_350"></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <div class="flex align-items-center p16 back-fff" v-if="getPermission('ymsSupplierMerchant_updateSupplierCompanyInfo')">
        <Button class="mr15" v-if="!editPriseInfo" type="primary" @click="modifyBtn">{{ $t('key1003503') }}</Button>
        <div v-else class="flex align-items-center">
          <Button class="mr15" type="primary" @click="submitForReviewBtn">{{ $t('key1003076') }}</Button>
          <Button class="mr15" @click="cancelBtn('prise')">{{ $t('key1000112') }}</Button>
        </div>
      </div>
    </div>
    <!--店铺信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002797') }}</h2>
        </template>
        <Form :model="enterpriseStoreForm" ref="enterpriseStoreForm" :rules="enterpriseStoreRuleValidate" :label-width="170" @submit.native.prevent>
          <Row>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002774')" prop="shopName">
                <span v-if="!editStoreInfo" class="labelText">{{ enterpriseStoreForm.shopName || '-' }}</span>
                <Input v-else v-model.trim="enterpriseStoreForm.shopName" :placeholder="$t('key1002775')" clearable class="width_350"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002776')" prop="shopLogoPath" class="required_style_label">
                <Upload
                  class="upload_styles"
                  ref="upload"
                  type="drag"
                  name="files"
                  v-if="editStoreInfo"
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'shopLogoPath')"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="20480"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <div class="img_style" v-if="enterpriseStoreForm.shopLogoPath">
                    <img :src="setImgPath(enterpriseStoreForm.shopLogoPath)" alt=""/>
                  </div>
                  <div class="upload_icon_box" v-else>
                    <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(enterpriseStoreForm.shopLogoPath)" alt=""/>
                <p class="font-size-12">{{ $t('key1002798') }}</p>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002777')" prop="managementModel">
                <span class="labelText">{{ enterpriseStoreForm.managementModel || '-' }}</span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002778')" prop="plannedBusinessCategory">
                <span class="labelText">
                  {{ enterpriseStoreForm.plannedBusinessCategory.length > 0 ? enterpriseStoreForm.plannedBusinessCategory : '-' }}
                </span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002779')" prop="shelvesProductsNumber" class="width_350">
                <span class="labelText">{{ enterpriseStoreForm.shelvesProductsNumber || '-' }}</span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002780')" prop="productReleaseNumber" class="reset_input_styles">
                <span class="labelText">{{ enterpriseStoreForm.productReleaseNumber || '-' }}</span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002782')" prop="businessAddress">
                <span class="labelText">{{ enterpriseStoreForm.businessAddress ? enterpriseStoreForm.businessAddress : '-' }}</span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="address">
                <span class="labelText">{{ enterpriseStoreForm.address || '-' }}</span>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1006790')">
                <div class="flex align-items-center">
                  <span class="basic_txt" style="margin-right: 8px;">{{ currencyName }}</span>
                  <span class="themeColor cursor" @click="$refs['changeCurrency'].initCurrencyData('editSupplier', 2, currency)">{{ $t('key1005513') }} ></span>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1006791')">
                <div class="flex align-items-center">
                  <span class="basic_txt" style="margin-right: 8px;">{{ placeOfOriginName }}</span>
                  <span class="themeColor cursor" @click="$refs['changePlaceOfOrigin'].initPlaceOfOriginData(originalCountryCode)">
                    {{ originalCountryCode ? $t('key1006792') : $t('key1006793') }}
                  </span>
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <div class="flex align-items-center p16 back-fff" v-if="getPermission('ymsSupplierMerchant_updateSupplierRegisterInfo')">
        <Button class="mr15" v-if="!editStoreInfo" type="primary" @click="modifyStoreBtn">{{ $t('key1003503') }}</Button>
        <div v-else class="flex align-items-center">
          <Button class="mr15" type="primary" @click="enterpriseStoreBtn">{{ $t('key1003076') }}</Button>
          <Button class="mr15" @click="cancelBtn('store')">{{ $t('key1000112') }}</Button>
        </div>
      </div>
    </div>
    <!--编辑币种弹窗-->
    <changeCurrencyModal ref="changeCurrency" @updateData="getSystemCurrencyData()"></changeCurrencyModal>
    <!--驳回原因弹窗-->
    <Modal v-model="reasonForRejectionModal" :title="currentRejectTitle" :width="700" :transfer="false" :mask-closable="true" footer-hide>
      <div class="font-size-13 color-333">{{ pageParams.auditRemarks }}</div>
    </Modal>
    <!--修改原产地弹窗-->
    <changeTheOriginOfTheProductModal
      ref="changePlaceOfOrigin"
      @updatePlaceOfOrigin="(value) => getOriginOfTheGoods(value)">
    </changeTheOriginOfTheProductModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import changeCurrencyModal from "@/components/common/changeCurrencyModal";
import changeTheOriginOfTheProductModal from "@/views/supplier/components/accountManage/changeTheOriginOfTheProductModal.vue";
import languagesTabs from "@/components/common/languagesTabs.vue";
import {currencyNameCode, getAllCountrysData, getCurrencyData, getDataSetBatchList, getEnumList, commonLocalStorage} from "@/utils/common";

export default {
  name: "basicInformation",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      twoItemCol: 12,
      pageParams: {},
      currencyName: '',
      currency: null,
      countrysList: [],
      editPriseInfo: false,
      editStoreInfo: false,
      placeOfOriginName: null,
      //企业信息
      enterpriseInfoForm: {
        businessLicensePath: '', // 营业执照
        identificationCardBackPath: null, // 法人身份证国徽面
        identificationCardPath: null, // 法人身份证人像面
        scale: null, // 经营规模:1.10人以下、2.10~30人、3.30~50人、4.50~100人、5.100人以上
        contacts: '', // 联系人
        contactsPhone: '', // 联系人手机号码
        phone: '', // 固定电话
        email: '', // 邮箱
        scaleName: '',
      },
      enterpriseInfoRuleValidate: {
        scale: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002728'), trigger: 'change', type: 'number'}],
        contacts: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002729'), trigger: 'blur'}],
        contactsPhone: [{required: true, validator: v.validateMobile(), trigger: 'blur'}],
        phone: [{required: false, validator: v.validateFixedTelephone(), trigger: 'blur'}],
        email: [{validator: v.validateMailboxFormat(false), trigger: 'blur'}],
      },
      // 店铺信息
      enterpriseStoreForm: {
        shopName: '', // 店铺名称
        shopLogoPath: null, // 店铺logo
        managementModel: null, // 经营模式 1.自有工厂、2.渠道代理、3.经销批发
        plannedBusinessCategory: [], //  类目:1.经营类目  类目值:1.女装、2.男装、3.男童、4.女童、5.婴童
        shelvesProductsNumber: null, // 预计上架商品数  1.10以下 2.10~30 3.30~50 4.50~100 5.100以上
        productReleaseRate: null, // 商品发布频率:0.待定、1.每天发布、2.每周发布、3.每月发布
        productReleaseNumber: null, // 商品发布数
        businessAddress: null, // 营业地址
        address: '', // 详细地址
      },
      enterpriseStoreRuleValidate: {
        shopName: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002730'), trigger: 'blur'}],
      },
      scaleList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002735')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002736')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002737')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002738')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002739')}
      ], // 经营规模
      groundingList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002740')},
        {value: 2, name: '10~30'},
        {value: 3, name: '30~50'},
        {value: 4, name: '50~100'},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002741')}
      ], // 预计上架商品数
      stateData: [],
      ymsMerchantStoreId: null,
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002742') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      reasonForRejectionModal: false,
      currentRejectTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000603'),
      auditAlertConfigs: [
        { key: 'updateSupplierAuditStatus', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006786'), type: 'company' },
        { key: 'updateSupplierStoreAuditStatus', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002797'), type: 'store' }
      ],
      businessAddressData: [],
      enumData: [],
      originalCountryCode: null
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 经营模式
    managementModelList() {
      const ENUM_KEY = 'YmsMerchantStoreManagementModelCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 发布类型
    releaseTypeList() {
      const ENUM_KEY = 'YmsMerchantStoreProductReleaseRateCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 计划经营类目
    plannedBusinessCategoryList() {
      const ENUM_KEY = 'YmsMerchantStoreAttributeAttributeValueCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 商品默认原产地国
    defaultOriginOfTheProduct() {
      const obj = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      return obj?.productDefaultOriginalCountryCode;
    },
    // 当前激活的审核提示列表
    activeAuditAlerts() {
      let alerts = [];
      this.auditAlertConfigs.forEach(config => {
        let status = this.pageParams[config.key];
        if (status === null || status === undefined) return;
        let item = { ...config, status };
        if (status === 0) {
          item.alertType = 'error';
          item.text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006782')}${config.label}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006783')}`;
          item.hasRejectReason = true;
        } else if (status === 1) {
          item.alertType = 'warning';
          item.text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006782')}${config.label}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006784')}`;
          item.hasRejectReason = false;
        } else if (status === 2) {
          item.alertType = 'success';
          item.text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006782')}${config.label}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006785')}`;
          item.hasRejectReason = false;
        }
        alerts.push(item);
      });
      return alerts;
    },
  },
  created() {
    this.initMultilingualFields('enterpriseInfoForm', this.enterpriseInfoForm, ['name_']);
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = [
          'YmsMerchantStoreManagementModelCoreEnum',
          'YmsMerchantStoreProductReleaseRateCoreEnum',
          'YmsMerchantStoreAttributeAttributeValueCoreEnum'
        ];
        this.enumData = await getDataSetBatchList(enumKeyList);
        let data = await getAllCountrysData('cn', true);
        this.countrysList = data.filter((item) => item.twoCode === 'CN');
        await getCurrencyData();
        await this.getSystemCurrencyData();
        await this.getSuppliersInfo();
        await this.getOriginOfTheGoods(this.defaultOriginOfTheProduct);
      })();
      // 默认拿国内地址
      this.getProvinceBasicData('CN').then((list) => {
        this.businessAddressData = list || [];
      });
    },
    // 商品原产地
    async getOriginOfTheGoods(code) {
      const country = this.countrysList.find((ele) => {
        return ele.twoCode === code;
      });
      this.originalCountryCode = country ? country.twoCode : null;
      this.placeOfOriginName = country ? country.name : null;
    },

    // 关闭审核通过提示
    closeAuditAlert(type) {
      let v = this;
      v.axios.get(api.get_ymsSupplierMerchant_closeAuditTips + v.userInfo.merchantId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            if (type === 'company') {
              v.pageParams.updateSupplierAuditStatus = null;
            } else if (type === 'store') {
              v.pageParams.updateSupplierStoreAuditStatus = null;
            }
          }
        }
      });
    },
    // 查看驳回原因
    showRejectReason(label) {
      this.currentRejectTitle = label + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000603');
      this.reasonForRejectionModal = true;
    },

    // 获取供应商基本信息
    getSuppliersInfo(type) {
      let v = this;
      v.ymsMerchantStoreId = null;
      v.axios.get(api.get_ymsSupplierMerchant_info).then(response => {
        if (response.data.code === 0) {
          let details = response.data.datas;
          if (details) {
            v.pageParams = details;
            let obj = v.handleMultilingualFormFields(details, ['name']);
            let enterpriseInfo = Object.assign({}, details, obj);

            // 处理企业信息
            function processingEnterpriseInfo(obj) {
              v.enterpriseInfoForm = obj;
              let keyList = [
                'businessLicensePath',
                'identificationCardBackPath',
                'identificationCardPath',
                'contacts',
                'contactsPhone',
                'phone',
                'email',
              ];
              keyList.map((key) => {
                v.enterpriseInfoForm[key] = obj[key];
              });
              v.scaleList.map((ele) => {
                if (ele.value === obj.scale) {
                  v.enterpriseInfoForm['scaleName'] = ele.name;
                }
              });
            }

            // 处理店铺信息
            function processingStoreInfo(obj) {
              // 店铺信息
              let storesObj = obj.ymsMerchantStore;
              if (storesObj) {
                v.pageParams.updateSupplierStoreAuditStatus = storesObj.updateSupplierStoreAuditStatus;
                v.ymsMerchantStoreId = storesObj.ymsMerchantStoreId;
                let storeskeyList = ['shopLogoPath', 'productReleaseNumber'];
                storeskeyList.map((key) => {
                  v.enterpriseStoreForm[key] = storesObj[key];
                });
                let selectStoreskeyList = ['managementModel', 'shelvesProductsNumber', 'productReleaseRate'];
                let selectStoresKeyObj = {
                  managementModel: v.managementModelList,
                  shelvesProductsNumber: v.groundingList,
                  productReleaseRate: v.releaseTypeList,
                };

                selectStoreskeyList.map((key) => {
                  let list = selectStoresKeyObj[key];
                  if (list.length > 0) {
                    list.map((ele) => {
                      if (ele.value === storesObj[key]) {
                        v.enterpriseStoreForm[key] = ele.name;
                      }
                    });
                  }
                });
                let productReleaseName = v.enterpriseStoreForm.productReleaseRate + v.enterpriseStoreForm.productReleaseNumber + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002749');
                v.enterpriseStoreForm.productReleaseNumber = v.enterpriseStoreForm.productReleaseRate !== aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002750') ? productReleaseName : v.enterpriseStoreForm.productReleaseRate;
                v.enterpriseStoreForm.shopName = storesObj.name;
                let ymsMerchantStoreAttributes = storesObj.ymsMerchantStoreAttributes || [];
                if (ymsMerchantStoreAttributes.length > 0) {
                  v.ymsMerchantStoreAttributes = ymsMerchantStoreAttributes;
                  let categoryList = [];
                  ymsMerchantStoreAttributes.map((item) => {
                    v.plannedBusinessCategoryList.map((ele) => {
                      if (ele.value === item.attributeValue) {
                        categoryList.push(ele.name);
                      }
                    });
                  });
                  v.enterpriseStoreForm.plannedBusinessCategory = categoryList.join('、');
                }
                // 处理地址信息
                let ymsMerchantStoreAddresses = storesObj.ymsMerchantStoreAddresses || [];
                v.enterpriseStoreForm.businessAddress = '';
                if (ymsMerchantStoreAddresses.length > 0) {
                  let addressesInfo = ymsMerchantStoreAddresses[0];
                  v.enterpriseStoreForm.businessAddress = v.handleAddressName(addressesInfo, v.businessAddressData);
                  v.enterpriseStoreForm.address = obj.address ? obj.address : addressesInfo.street;
                }
              }
            }

            if (type) {
              if (type === 'updateStore') {
                processingStoreInfo(details);
              } else {
                processingEnterpriseInfo(enterpriseInfo);
              }
            } else {
              processingEnterpriseInfo(enterpriseInfo);
              processingStoreInfo(details);
            }
            v.$forceUpdate();
          }
        }
      });
    },
    // 获取系统配置的币种
    getSystemCurrencyData() {
      let v = this;
      let currency = v.$store.state.erpConfig.currency;
      if (currency) {
        v.currencyName = currencyNameCode(currency);
        v.currency = currency;
      }
      v.axios.post(api.post_erpCommonSettingParam_queryMerchantByParamKeys, ['ymsSupplierCurrency']).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data.length > 0) {
            data.map((item) => {
              if (item.paramKey === 'ymsSupplierCurrency') {
                v.currency = item.paramValue;
                v.currencyName = currencyNameCode(item.paramValue);
                v.$forceUpdate();
              }
            });
          }
        }
      });
    },
    // （营业执照、法人身份证、店铺logo）--上传成功
    uploadSuccess(response, file, fileList, type) {
      let v = this;
      let uploadList = [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002751'), key: 'businessLicensePath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002752'), key: 'identificationCardBackPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002753'), key: 'identificationCardPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002754'), key: 'shopLogoPath'},
      ];
      uploadList.map((item) => {
        if (item.key === type) {
          let data = response.datas[0];
          if (response.code === 0) {
            if (item.key === 'shopLogoPath') {
              v.enterpriseStoreForm[item.key] = data;
            } else {
              v.enterpriseInfoForm[item.key] = data;
            }
            v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
          } else {
            v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
          }
        }
      });
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002726')}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 修改企业信息
    modifyBtn() {
      if (this.pageParams.updateSupplierAuditStatus === 1) {
        this.$Modal.warning({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006787'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000248'),
        });
      } else {
        this.editPriseInfo = true;
      }
    },
    // 修改店铺信息
    modifyStoreBtn() {
      if (this.pageParams.updateSupplierStoreAuditStatus === 1) {
        this.$Modal.warning({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006788'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000248'),
        });
      } else {
        this.editStoreInfo = true;
      }
    },
    // 取消编辑企业、店铺信息
    cancelBtn(type) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005951'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006789'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          if (type === 'store') {
            this.$refs['enterpriseStoreForm'].resetFields();
            this.editStoreInfo = false;
            this.$nextTick(() => {
              this.getSuppliersInfo('updateStore');
            });
          } else {
            this.$refs['enterpriseInfoForm'].resetFields();
            this.editPriseInfo = false;
            this.$nextTick(() => {
              this.getSuppliersInfo('updatePrise');
            });
          }
        },
        onCancel: () => {
        }
      });
    },
    // 提交审核
    submitForReviewBtn() {
      let v = this;
      let query = {
        name: v.handleMultilingualSingleParam(v.enterpriseInfoForm, 'name_'),
        ymsMerchantId: v.pageParams.ymsMerchantId
      };
      let keyList = [
        'scale',
        'contacts',
        'contactsPhone',
        'email',
        'phone',
        'businessLicensePath',
        'identificationCardBackPath',
        'identificationCardPath'
      ];
      v.$refs['enterpriseInfoForm'].validate((valid) => {
        if (!valid) return;
        // 校验上传的图片
        let uloadImgList = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002755'), key: 'businessLicensePath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002756'), key: 'identificationCardBackPath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002757'), key: 'identificationCardPath'}
        ];
        for (let i = 0; i < uloadImgList.length; i++) {
          let item = uloadImgList[i];
          if (!v.enterpriseInfoForm[item.key]) {
            v.$Message.warning(item.title);
            return;
          }
        }
        for (let key of keyList) {
          query[key] = v.enterpriseInfoForm[key];
        }
        v.axios.post(api.post_ymsSupplierMerchant_updateSupplierCompanyInfo, query, {
          loading: true,
          loaddingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
        }).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
            v.getSuppliersInfo('updatePrise');
            v.editPriseInfo = false;
            v.$forceUpdate();
          }
        });
      });
    },
    // 保存店铺信息
    enterpriseStoreBtn() {
      let v = this;
      let query = {
        updateSupplierRegisterStoreInfo: {
          name: v.enterpriseStoreForm.shopName,
          shopLogoPath: v.enterpriseStoreForm.shopLogoPath,
          ymsMerchantStoreId: v.ymsMerchantStoreId || null
        },
        ymsMerchantId: v.pageParams.ymsMerchantId
      };
      v.$refs['enterpriseStoreForm'].validate((valid) => {
        if (valid) {
          if (!v.enterpriseStoreForm.shopLogoPath) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002758'));
            return false;
          }
          v.axios.post(api.post_ymsSupplierMerchant_updateSupplierRegisterInfo, query, {
            loading: true,
            loaddingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.editStoreInfo = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
              v.getSuppliersInfo('updateStore');
              v.$forceUpdate();
            }
          });
        }
      });
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let v = this;
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002742') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    }
  },
  components: {
    languagesTabs,
    changeCurrencyModal,
    changeTheOriginOfTheProductModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 14px !important;
}

.details_box_styles {
  .basic_information_box {
    .viewImgStyles {
      width: 120px;
      height: 120px;
      display: inline-block;
      object-fit: cover;
      vertical-align: middle;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #D7D7D7;
      box-sizing: border-box;
      cursor: pointer;
    }

    /deep/ .upload_styles {
      .ivu-upload.ivu-upload-drag {
        width: 120px;
        height: 120px;
      }

      .upload_icon_box {
        width: 120px;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
      }

      .img_style {
        width: 120px;
        height: 120px;

        img {
          width: 100%;
          height: 100%;
          display: inline-block;
          object-fit: cover;
          vertical-align: middle;
        }
      }
    }

    .labelText {
      position: relative;
      top: 1px;
    }

    .basic_item {
      .img_styles {
        width: auto;
        height: 125px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        max-width: 300px;
      }
    }

    .shippingAddress_box {
      margin-bottom: 10px;

      .title {
        font-size: 15px;
        font-weight: bold;
        color: #000;
      }
    }

    .warehouseConfig_box {
      position: relative;

      .warehouseConfig_box_item {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
        cursor: pointer;
        margin: 0;
      }
    }
  }

  .audit_alerts_wrapper {
    position: fixed;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 910;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;

    .alert_content_box {
      width: fit-content;
      min-width: 400px;
      max-width: 700px;
      pointer-events: auto;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

      /deep/ .ivu-alert-icon {
        font-size: 23px;
        top: 4px;
        left: 7px;
      }
    }
  }
}
</style>
